import { useMemo } from 'react';
import {
  getStartEventTypes,
  getSimplifiedInputEventTypes,
  getEndEventTypes,
  type InputEventTypeOption
} from '@bliks-io/ui';

export interface DraftEditorDialogOptions {
  startEventTypes: InputEventTypeOption[];
  intermediateEventTypes: InputEventTypeOption[];
  endEventTypes: InputEventTypeOption[];
}

/**
 * Bundles the input dialog's event-type options for the draft editor's
 * step-detail panels. The entity *pickers* (successors, assignee, helpers)
 * fetch their own data, and the entity *display* surfaces resolve names via the
 * shared `useAssigneeLookup`, so no entity lists are bundled here.
 */
export function useDialogOptionsForDraftEditor(): DraftEditorDialogOptions {
  return useMemo(
    () => ({
      startEventTypes: getStartEventTypes(),
      intermediateEventTypes: getSimplifiedInputEventTypes(),
      endEventTypes: getEndEventTypes()
    }),
    []
  );
}
